import { useContext } from "react";

import { TransactableContext } from "../context/TransactableContext";

// this is a hook that returns the transactable context provider
// checkTransactable(optionalCB)
// next()
// transactionProcessing
// setTransactionProcessing(boolean)
// readyToTransact
// transactableState
// totalPendingReviews
// currentPendingReview
// pendingReviewsIndex

export const useTransactable = () => {
  return useContext(TransactableContext);
};
